import GSObjectArray from "./GSObjectArray";
import GenerateUUID from "./GenerateGUID";

export default class GSOUUIDArray extends GSObjectArray {
    // Returns the item in the array that matches the UUID parameter. Return null if item cannot be found.
    findByUUID(uuid) {
        for (let i = 0; i < this.length; i++) {
            if (this[i].uuid === uuid) {
                return this[i];
            }
        }
        return null;
    }

    // Push items to array and create and set UUID for those items (As long as UUID on item is not set or empty).
    push(...args) {
        for (let i = 0; i < args.length; i++) {
            const item = args[i];
            if (!item.uuid || item.uuid === "") {
                item.uuid = GenerateUUID();
            }
        }
        super.push(...args);
    }
}